import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SummaryCashModel } from '../../models/summary-cash.model';


export enum CashActionTypes {
  LoadCashs = '[CashAccount] Load Cashs',
  LoadCashsSuccess = '[CashAccount] Load Cashs Success',
  LoadCashsFailure = '[CashAccount] Load Cashs Failure',

  LoadCash = '[CashAccount] Load Cash',
  LoadCashSuccess = '[CashAccount] Load Cash Success',
  LoadCashFailure = '[CashAccount] Load Cash Failure',

  CreateCash = '[CashAccount] Create Cash',
  CreateCashSuccess = '[CashAccount] Create Cash Success',
  CreateCashFailure = '[CashAccount] Create Cash Failure',

  UpdateCash = '[CashAccount] Update Cash',
  UpdateCashSuccess = '[CashAccount] Update Cash Success',
  UpdateCashFailure = '[CashAccount] Update Cash Failure',

  DeleteCash = '[CashAccount] Delete Cash',
  DeleteCashSuccess = '[CashAccount] Delete Cash Success',
  DeleteCashFailure = '[CashAccount] Delete Cash Failure',
}

/** Load all */

export class LoadCashs implements Action {
  readonly type = CashActionTypes.LoadCashs;
  constructor(public payload: {filter: any}) {}
}

export class LoadCashsSuccess implements Action {
  readonly type = CashActionTypes.LoadCashsSuccess;
  constructor(public payload: { items: SummaryCashModel[]; total: number }) {}
}

export class LoadCashsFailure implements Action {
  readonly type = CashActionTypes.LoadCashsFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadCash implements Action {
  readonly type = CashActionTypes.LoadCash;
  constructor(public payload: { uid: string }) {}
}

export class LoadCashSuccess implements Action {
  readonly type = CashActionTypes.LoadCashSuccess;
  constructor(public payload: SingleResponseModel<SummaryCashModel>) {}
}

export class LoadCashFailure implements Action {
  readonly type = CashActionTypes.LoadCashFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateCash implements Action {
  readonly type = CashActionTypes.CreateCash;
  constructor(public payload: { cash: SummaryCashModel }) {}
}


export class CreateCashSuccess implements Action {
  readonly type = CashActionTypes.CreateCashSuccess;
  constructor(public payload: { cash: SummaryCashModel }) {}
}

export class CreateCashFailure implements Action {
  readonly type = CashActionTypes.CreateCashFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateCash implements Action {
  readonly type = CashActionTypes.UpdateCash;
  constructor(public payload: { cash: SummaryCashModel }) {}
}

export class UpdateCashSuccess implements Action {
  readonly type = CashActionTypes.UpdateCashSuccess;
  constructor(public payload: { cash: SummaryCashModel }) {}
}

export class UpdateCashFailure implements Action {
  readonly type = CashActionTypes.UpdateCashFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteCash implements Action {
  readonly type = CashActionTypes.DeleteCash;
  constructor(public payload: { uid: string }) {}
}

export class DeleteCashSuccess implements Action {
  readonly type = CashActionTypes.DeleteCashSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteCashFailure implements Action {
  readonly type = CashActionTypes.DeleteCashFailure;
  constructor(public payload: { error: any }) {}
}

export type CashActions =
  | LoadCashs
  | LoadCashsSuccess
  | LoadCashsFailure
  | LoadCash
  | LoadCashSuccess
  | LoadCashFailure
  | CreateCash
  | CreateCashSuccess
  | CreateCashFailure
  | UpdateCash
  | UpdateCashSuccess
  | UpdateCashFailure
  | DeleteCash
  | DeleteCashSuccess
  | DeleteCashFailure
